<template>

	<img :src="getIcon" :class="getClass" :title="getClass" />
</template>

<script>
export default {
	name: "Icon",

	props: {
		icon: String,
		class: String,
		link: {
			type: Boolean,
			default: true
		},
		fileName: String
	},
	computed: {
		getIcon() {
			if (this.fileName) {
				return require("@/assets/" + this.fileName + ".png");
			}
			if (this.icon == null) {
				return require("@/assets/icon.png");
			}

			if (this.icon.toLowerCase() == "spinner") {
				return require("@/assets/circle_spinner.png");
			}

			if (this.icon.toLowerCase() == "reload") {
				return require("@/assets/w3_button_reload_grey.png");
			}

			if (this.icon.toLowerCase() == "bars-dark") {
				return require("@/assets/w3_bars_dark.png");
			}
			if (this.icon.toLowerCase() == "reload-dark") {
				return require("@/assets/button_reload_dark.png");
			}
			if (this.icon.toLowerCase() == "reload-light") {
				return require("@/assets/w3_button_reload_grey_light.png");
			}

			if (this.icon.toLowerCase() == "trash-light") {
				return require("@/assets/w3_trash_light.png");
			}


			if (this.icon.toLowerCase() == "trash-dark") {
				return require("@/assets/w3_trash_dark.png");
			}

			return require("@/assets/icon.png");
		},
		getClass() {
			var css = this.icon;

			if (this.class) {
				css += " " + this.class;
			}

			if (this.link) {
				css += " link";
			}

			if (this.icon && this.icon.toLowerCase() == "spinner") {
				css = "spinning";
			}

			return css;
		}
	}
}

</script>

<style scoped>
img {
	width: 30px;
	height: 30px;
}
</style>